"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAccountDropdown = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactResponsive = require("react-responsive");
var _reactI18next = require("react-i18next");
var _utils = require("../../../../utils");
var _ui = require("../../../ui");
var _excluded = ["email", "logout", "dropdownToggleInnerComponent", "onSettingsClick"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var UserEmail = (0, _styledComponents.default)(_ui.Small)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  font-size: 14px;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var getExceededAsterisks = function getExceededAsterisks(str, size) {
  return str.length > size ? new Array(4).join('*') : '';
};
var maskEmail = function maskEmail(email) {
  var maxSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  var _email$split = email.split('@'),
    _email$split2 = _slicedToArray(_email$split, 2),
    name = _email$split2[0],
    domain = _email$split2[1];
  var maskedName = getExceededAsterisks(name, maxSize);
  var maskedDomain = getExceededAsterisks(domain, maxSize);
  return "".concat(name.slice(0, maxSize) + maskedName, "@").concat(maskedDomain + domain.slice(-maxSize));
};
var UserAccountDropdown = function UserAccountDropdown(_ref2) {
  var email = _ref2.email,
    logout = _ref2.logout,
    DropdownToggleInnerComponent = _ref2.dropdownToggleInnerComponent,
    onSettingsClick = _ref2.onSettingsClick,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libLayout'),
    t = _useTranslation.t;
  var isSm = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  var isTable = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  var maskedEmail = isTable ? maskEmail(email) : email;
  return /*#__PURE__*/_react.default.createElement(_ui.Dropdown, props, /*#__PURE__*/_react.default.createElement(_ui.DropdownToggle, {
    className: "d-flex flex-column align-items-center align-items-md-end",
    caret: false
  }, DropdownToggleInnerComponent && /*#__PURE__*/_react.default.createElement(DropdownToggleInnerComponent, null), /*#__PURE__*/_react.default.createElement(UserEmail, null, maskedEmail)), !isSm && /*#__PURE__*/_react.default.createElement(_ui.DropdownMenu, {
    right: true
  }, /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.profileSettings'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "settings"
    }),
    onClick: onSettingsClick
  }), /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItem, {
    title: t('dashboard.header.logout'),
    icon: /*#__PURE__*/_react.default.createElement(_ui.DropdownMenuItemIcon, {
      name: "exit"
    }),
    onClick: logout
  })));
};
exports.UserAccountDropdown = UserAccountDropdown;